// extracted by mini-css-extract-plugin
module.exports = {"back":"BackToTop_back__2sgTQ","active":"BackToTop_active__33v40"};